import { responseService } from '@aceroll/platform-hacksaw';

// controllers
import { EvMaxWin } from '../controllers/ev-max-win';
import { EvRespin } from '../controllers/ev-respin';
import { RoundCompleted } from '../controllers/round-completed';

export function evRespinDecision() {
    const event = responseService.getEvent();
    if (!event) {
        return RoundCompleted;
    }
    switch (event.type) {
        case 'respin':
            return EvRespin;
        case 'max_win_reached':
            return EvMaxWin;
        default:
            return RoundCompleted;
    }
}
